import { Routes } from "@angular/router";
import { LoginComponent } from "../authentication/pages/login/login.component";
import { DashboardComponent } from "../dashboards/dashboard/dashboard.component";
import { LandingpageComponent } from "../dashboards/landingpage/landingpage.component";
import { LocationComponent } from "../mds/settings/pages/location/location.component";
import { ExpenseHeadComponent } from "../mds/settings/pages/expensehead/expensehead.component";
import { CompanyComponent } from "../mds/settings/pages/company/company.component";
import { DivisionComponent } from "../mds/settings/pages/division/division.component";
import { DepartmentComponent } from "../mds/settings/pages/department/department.component";
import { SubDepartmentComponent } from "../mds/settings/pages/subdepartment/subdepartment.component";
import { ModuleComponent } from "../mds/settings/pages/module/module.component";
import { RolemasterComponent } from "../mds/settings/pages/rolemaster/rolemaster.component";
import { MainMenuComponent } from '../utils/elements/menu/mainmenu.component';
import { MenuComponent } from "../mds/settings/pages/menu/menu.component";
import { LandingMenuComponent } from "../utils/elements/landing-menu/landing-menu.component";
import { AddUserComponent } from "../mds/settings/pages/add-user/add-user.component";
import { ForgotpwdComponent } from "../mds/settings/pages/forgotpwd/forgotpwd.component";
import { PasswordresetComponent } from "../mds/settings/pages/passwordreset/passwordreset.component";
import { AdminPortalComponent } from "../mds/settings/pages/admin-portal/admin-portal.component";
import { DesignationComponent } from "../mds/settings/pages/designation/designation.component";
import { UnitComponent } from "../mds/settings/pages/unit/unit.component";
import { CommitteeComponent } from "../mds/settings/pages/committee/committee.component";
import { EmployeeComponent } from "../mds/settings/pages/employee/employee.component";
import { CurrencyComponent } from "../mds/settings/pages/currency/currency.component";
import { DesignationLevelComponent } from "../mds/settings/pages/designationlevel/designationlevel.component";
import { CurrencyUnitComponent } from "../mds/settings/pages/currencyunit/currencyunit.component";
import { FinYearComponent } from "../mds/settings/pages/finyear/finyear.component";
import { PurposeComponent } from "../mds/settings/pages/purpose/purpose.component";
import { MeetingmasterComponent } from "../mds/settings/pages/meetingmaster/meetingmaster.component";
import { MeetingtypeComponent } from "../mds/settings/pages/meetingtype/meetingtype.component";
import { DelegationComponent } from "../mds/settings/pages/delegation/delegation.component";
import { VenueComponent } from "../mds/settings/pages/venue/venue.component";
import { ActComponent } from "../mds/settings/pages/act/act.component";
import { FacilityComponent } from "../mds/settings/pages/facility/facility.component";
import { FacilityManagerComponent } from "../mds/settings/pages/facilitymanager/facilitymanager.component";
import { SectionComponent } from "../mds/settings/pages/section/section.component";
import { AgendaPriorityComponent } from "../mds/settings/pages/agendapriority/agendapriority.component";
import { InviteeTypeComponent } from "../mds/settings/pages/inviteetype/inviteetype.component";
import { PositionComponent } from "../mds/settings/pages/position/position.component";
import { ZoneComponent } from "../mds/settings/pages/zone/zone.component";
import { StateComponent } from "../mds/settings/pages/state/state.component";
import { RegionComponent } from "../mds/settings/pages/region/region.component";
import { ClusterComponent } from "../mds/settings/pages/cluster/cluster.component";
import { DirectorComponent } from "../mds/settings/pages/director/director.component";
import { ParentDepartment } from "../mds/settings/models/parentdepartment";
import { ParentdepartmentComponent } from "../mds/settings/pages/parentdepartment/parentdepartment.component"
import { WorkflowComponent } from "../mds/settings/pages/workflow/workflow.component";

export const routes: Routes = [
    { path: 'login', component: LoginComponent },
    //{ path: 'login/cn/:val', component: LoginComponent },
    {
        path: 'landingpage', component: LandingpageComponent,
        children: [
            { path: 'dashboard', component: DashboardComponent },
            { path: 'branch', component: LocationComponent },
            { path: 'rolemaster', component: RolemasterComponent },
            { path: 'menu/:id', component: MainMenuComponent },
            { path: 'menu/:id/main-menu/:mid', component: MainMenuComponent },
            { path: 'landing-menu', component: LandingMenuComponent },
            { path: 'module', component: ModuleComponent },
            { path: 'rolemaster', component: RolemasterComponent },
            { path: 'company', component: CompanyComponent },
            { path: 'designation', component: DesignationComponent },
            { path: 'unit', component: UnitComponent },
            { path: 'designationlevel', component: DesignationLevelComponent },
            { path: 'currencyunit', component: CurrencyUnitComponent },
            { path: 'finyear', component: FinYearComponent },
            { path: 'employee', component: EmployeeComponent },
            { path: 'expensehead', component: ExpenseHeadComponent },
            { path: 'menu', component: MenuComponent },
            { path: 'department', component: DepartmentComponent },
            { path: 'committee', component: CommitteeComponent },
            { path: 'currency', component: CurrencyComponent },
            { path: 'subdepartment', component: SubDepartmentComponent },
            { path: 'division', component: DivisionComponent },
            { path: 'add-user', component: AddUserComponent },
            { path: 'forgot-password', component: ForgotpwdComponent },
            { path: 'reset-password', component: PasswordresetComponent },
            { path: 'admin-portal', component: AdminPortalComponent },
            { path: 'purpose', component: PurposeComponent },
            { path: 'meeting', component: MeetingmasterComponent },
            { path: 'meetingtype', component: MeetingtypeComponent },
            { path: 'delegation', component: DelegationComponent },
            { path: 'venue', component: VenueComponent },
            { path: 'act', component: ActComponent },
            { path: 'section', component: SectionComponent },
            { path: 'facility', component: FacilityComponent },
            { path: 'facilitymanager', component: FacilityManagerComponent },
            { path: 'agendapriority', component: AgendaPriorityComponent },
            { path: 'inviteetype', component: InviteeTypeComponent },
            { path: 'position', component: PositionComponent },
            { path: 'zone', component: ZoneComponent },
            { path: 'state', component: StateComponent },
            { path: 'region', component: RegionComponent },
            { path: 'cluster', component: ClusterComponent },
            { path: 'director', component: DirectorComponent },
            { path: 'parentdepartment', component: ParentdepartmentComponent },
            { path: 'workflow', component: WorkflowComponent }

        ]
    },
    {
        path: 'mds', component: LandingpageComponent,
        children: [
        ]
    },

    { path: '', redirectTo: 'login', pathMatch: 'full' },
    { path: '**', redirectTo: 'login' }
];
